import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import EnterpriseDTO from '../interfaces/ip-enterprise-dto';
import EnterpriseUserEdition from '../interfaces/ip-enterprise-user-edition';
import NewUser from '../interfaces/ip-new-user';
import { PageResponse } from '../interfaces/ip-page-response';
import Pageable from '../interfaces/ip-pageable';
import { RoleResponse } from '../interfaces/ip-role-response';
import UserResponse, { UserDataSummary } from '../interfaces/ip-user-response';
import { UserTypePerson } from '../interfaces/ip-user-type-person';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class IpEnterpriseUserService {
  api = environment.api;

  constructor(private http: HttpClient) { }

  getRoles(subsidiaryId?: number) {
    let params = new HttpParams();
    if (subsidiaryId) {
      params = params.set('subsidiaryId', subsidiaryId);
    }
    return this.http.get<RoleResponse[]>(
      `${this.api}/invopay/enterprise/roles`,
      { params }
    );
  }

  getUsers(pageable: Pageable = {}) {
    let params = new HttpParams();
    if (typeof pageable.page !== 'undefined') {
      params = params.set('page', pageable.page);
    }
    if (pageable.size) {
      params = params.set('size', pageable.size);
    }
    if (pageable.sort) {
      params = params.set('sort', pageable.sort);
    }
    return this.http.get<PageResponse<UserResponse>>(
      `${this.api}/invopay/enterprises/employees/user`,
      { params }
    );
  }

  getAdmins(pageable: Pageable = {}) {
    let params = new HttpParams();
    if (typeof pageable.page !== 'undefined') {
      params = params.set('page', pageable.page);
    }
    if (pageable.size) {
      params = params.set('size', pageable.size);
    }
    if (pageable.sort) {
      params = params.set('sort', pageable.sort);
    }
    return this.http.get<PageResponse<UserResponse>>(
      `${this.api}/invopay/enterprises/employees/admin`,
      { params }
    );
  }

  getEmployees(pageable: Pageable = {}) {
    let params = new HttpParams();
    if (typeof pageable.page !== 'undefined') {
      params = params.set('page', pageable.page);
    }
    if (pageable.size) {
      params = params.set('size', pageable.size);
    }
    if (pageable.sort) {
      params = params.set('sort', pageable.sort);
    }
    return this.http.get<PageResponse<UserResponse>>(
      `${this.api}/invopay/enterprises/employees/employee`,
      { params }
    );
  }

  createUser(user: NewUser) {
    return this.http.post<void>(
      `${this.api}/invopay/enterprises/employees`,
      user
    );
  }

  updateUser(user: EnterpriseUserEdition, userId: number) {
    return this.http.put<EnterpriseDTO>(
      `${this.api}/invopay/enterprises/employees/${userId}`,
      user
    );
  }

  deleteUser(userId: number) {
    return this.http.delete<void>(
      `${this.api}/invopay/enterprises/employees/${userId}`
    );
  }

  getUserTypePersons(): Observable<UserTypePerson[]> {
    return this.http.get<UserTypePerson[]>(
      `${this.api}/invopay/users/type-person`
    );
  }

  deleteUserInvopay(userId: number) {
    return this.http.delete<void>(
      `${this.api}/invopay/users/${userId}`
    );
  }
  
  getUserInvopaySummary(userId: number): Observable<UserDataSummary> {
    return this.http.get<UserDataSummary>(
      `${this.api}/invopay/users/summary/${userId}`
    );
  }
}
